import React from 'react';
import Container from 'react-bootstrap/Container';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Button from 'react-bootstrap/Button';
import TermsEstonian from './TermsEstonian';
import PrivacyEstonian from './PrivacyEstonian';
import TermsLatvian from './TermsLatvian';
import PrivacyLatvian from './PrivacyLatvian';
import { Translate } from 'react-redux-i18n';
import { ApiLanguage } from '../../api';

export interface TermsAndPrivacyProps {
  color: string;
  onClose: () => void;
  language: ApiLanguage;
}

export const TermsAndPrivacy: React.FC<TermsAndPrivacyProps> = ({
  color,
  onClose,
  language,
}: TermsAndPrivacyProps) => {
  const getTermsComponent = () => {
    if (language == ApiLanguage.Latvian) {
      return <TermsLatvian />;
    } else {
      return <TermsEstonian />;
    }
  };

  const getPrivacyComponenet = () => {
    if (language == ApiLanguage.Latvian) {
      return <PrivacyLatvian />;
    } else {
      return <PrivacyEstonian />;
    }
  };

  return (
    <Container className='container col-lg-10' id='terms-privacy' fluid>
      <Tabs defaultActiveKey='terms' id='terms-and-privacy' className='mb-3' fill justify>
        <Tab eventKey='terms' title={<Translate value={'terms.termsTitle'} />}>
          {getTermsComponent()}
        </Tab>
        <Tab eventKey='privacy' title={<Translate value={'terms.privacyTitle'} />}>
          {getPrivacyComponenet()}
        </Tab>
      </Tabs>
      <div className='terms-button'>
        <Button style={{ backgroundColor: color, borderColor: color }} onClick={onClose} block>
          Ok
        </Button>
      </div>
    </Container>
  );
};

export default TermsAndPrivacy;
